import Hidden from 'raydiant-elements/layout/Hidden';
import { FC, useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SortFolderOptions } from '../../utilities';
import {
  selectLayoutOptions,
  selectSearchQuery,
  selectSortOptions,
} from './selectors';
import * as actions from './actions';
import { useDebounce } from 'use-debounce';
import Button from '@raydiant/raydial/components/Button';
import {
  ArrowDownArrowUp,
  Filter,
  List,
  Search,
  XMark,
} from '@raydiant/raydial/components/Icons';
import cn from 'classnames';
import Popover from '@raydiant/raydial/components/Popover';
import Dialog from '@raydiant/raydial/components/Dialog';

// Need to move to raydial
interface IconProps {
  className?: string;
  size?: number;
}

export const GridIcon = ({ className, size = 24 }: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.42188 5.51562H5.82812V7.10938H7.42188V5.51562ZM5.82812 4.1875H7.42188C8.15234 4.1875 8.75 4.78516 8.75 5.51562V7.10938C8.75 7.87305 8.15234 8.4375 7.42188 8.4375H5.82812C5.06445 8.4375 4.5 7.87305 4.5 7.10938V5.51562C4.5 4.78516 5.06445 4.1875 5.82812 4.1875ZM7.42188 10.8281H5.82812V12.4219H7.42188V10.8281ZM5.82812 9.5H7.42188C8.15234 9.5 8.75 10.0977 8.75 10.8281V12.4219C8.75 13.1855 8.15234 13.75 7.42188 13.75H5.82812C5.06445 13.75 4.5 13.1855 4.5 12.4219V10.8281C4.5 10.0977 5.06445 9.5 5.82812 9.5ZM5.82812 16.1406V17.7344H7.42188V16.1406H5.82812ZM4.5 16.1406C4.5 15.4102 5.06445 14.8125 5.82812 14.8125H7.42188C8.15234 14.8125 8.75 15.4102 8.75 16.1406V17.7344C8.75 18.498 8.15234 19.0625 7.42188 19.0625H5.82812C5.06445 19.0625 4.5 18.498 4.5 17.7344V16.1406ZM12.7344 5.51562H11.1406V7.10938H12.7344V5.51562ZM11.1406 4.1875H12.7344C13.4648 4.1875 14.0625 4.78516 14.0625 5.51562V7.10938C14.0625 7.87305 13.4648 8.4375 12.7344 8.4375H11.1406C10.377 8.4375 9.8125 7.87305 9.8125 7.10938V5.51562C9.8125 4.78516 10.377 4.1875 11.1406 4.1875ZM11.1406 10.8281V12.4219H12.7344V10.8281H11.1406ZM9.8125 10.8281C9.8125 10.0977 10.377 9.5 11.1406 9.5H12.7344C13.4648 9.5 14.0625 10.0977 14.0625 10.8281V12.4219C14.0625 13.1855 13.4648 13.75 12.7344 13.75H11.1406C10.377 13.75 9.8125 13.1855 9.8125 12.4219V10.8281ZM12.7344 16.1406H11.1406V17.7344H12.7344V16.1406ZM11.1406 14.8125H12.7344C13.4648 14.8125 14.0625 15.4102 14.0625 16.1406V17.7344C14.0625 18.498 13.4648 19.0625 12.7344 19.0625H11.1406C10.377 19.0625 9.8125 18.498 9.8125 17.7344V16.1406C9.8125 15.4102 10.377 14.8125 11.1406 14.8125ZM16.4531 5.51562V7.10938H18.0469V5.51562H16.4531ZM15.125 5.51562C15.125 4.78516 15.6895 4.1875 16.4531 4.1875H18.0469C18.7773 4.1875 19.375 4.78516 19.375 5.51562V7.10938C19.375 7.87305 18.7773 8.4375 18.0469 8.4375H16.4531C15.6895 8.4375 15.125 7.87305 15.125 7.10938V5.51562ZM18.0469 10.8281H16.4531V12.4219H18.0469V10.8281ZM16.4531 9.5H18.0469C18.7773 9.5 19.375 10.0977 19.375 10.8281V12.4219C19.375 13.1855 18.7773 13.75 18.0469 13.75H16.4531C15.6895 13.75 15.125 13.1855 15.125 12.4219V10.8281C15.125 10.0977 15.6895 9.5 16.4531 9.5ZM16.4531 16.1406V17.7344H18.0469V16.1406H16.4531ZM15.125 16.1406C15.125 15.4102 15.6895 14.8125 16.4531 14.8125H18.0469C18.7773 14.8125 19.375 15.4102 19.375 16.1406V17.7344C19.375 18.498 18.7773 19.0625 18.0469 19.0625H16.4531C15.6895 19.0625 15.125 18.498 15.125 17.7344V16.1406Z"
        fill="#A5A5A5"
      />
    </svg>
  );
};

export const Check = ({ className, size = 13 }: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 13 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1973 0.240234C12.4258 0.494141 12.4258 0.875 12.1973 1.10352L5.49414 7.80664C5.24023 8.06055 4.85938 8.06055 4.63086 7.80664L1.17773 4.35352C0.923828 4.125 0.923828 3.74414 1.17773 3.51562C1.40625 3.26172 1.78711 3.26172 2.01562 3.51562L5.03711 6.53711L11.334 0.240234C11.5625 0.0117188 11.9434 0.0117188 12.1719 0.240234H12.1973Z"
        fill="#0047D4"
      />
    </svg>
  );
};

export const UserIcon = ({ className, size = 24 }: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="5" fill="#E5EEFF" />
      <path
        d="M8.28857 5.3491H16.1945C16.9747 5.3491 17.6509 6.02527 17.6509 6.80546V14.2953C17.6509 14.8935 17.2868 15.3876 16.8187 15.6217V17.4161H17.0267C17.3648 17.4161 17.6509 17.7022 17.6509 18.0403C17.6509 18.4043 17.3648 18.6644 17.0267 18.6644H8.08052C6.91023 18.6644 6 17.7542 6 16.5839C6 16.5319 6 16.4539 6 16.3758V7.63767C6 6.38936 7.01425 5.3491 8.28857 5.3491ZM15.5704 15.7517H8.08052C7.6124 15.7517 7.24831 16.1418 7.24831 16.5839C7.24831 17.052 7.6124 17.4161 8.08052 17.4161H15.5704V15.7517ZM8.08052 14.5034H9.32883V14.0873C9.32883 12.943 10.2391 12.0068 11.4093 12.0068H13.0738C14.218 12.0068 15.1543 12.943 15.1543 14.0873V14.5034H16.1945C16.2986 14.5034 16.4026 14.4254 16.4026 14.2953V6.80546C16.4026 6.70143 16.2986 6.59741 16.1945 6.59741H8.28857C7.69042 6.59741 7.24831 7.06553 7.24831 7.63767V14.6854C7.48237 14.5814 7.76844 14.5034 8.08052 14.5034ZM12.2416 11.1745C11.6434 11.1745 11.0973 10.8625 10.7852 10.3423C10.4991 9.84822 10.4991 9.19806 10.7852 8.67793C11.0973 8.1838 11.6434 7.84572 12.2416 7.84572C12.8137 7.84572 13.3598 8.1838 13.6719 8.67793C13.958 9.19806 13.958 9.84822 13.6719 10.3423C13.3598 10.8625 12.8137 11.1745 12.2416 11.1745Z"
        fill="#044CD0"
      />
    </svg>
  );
};

interface AddContentActionBarProps {
  sortDisabled?: boolean;
}

const SEARCH_DEBOUNCE_TIMEOUT = 1000; //in ms

const AddContentActionBarV2: FC<AddContentActionBarProps> = ({
  sortDisabled,
}) => {
  const dispatch = useDispatch();
  const triggerRef = useRef(null);

  // Selectors

  const sortOptions = useSelector(selectSortOptions);
  const layoutOptions = useSelector(selectLayoutOptions);
  const searchQuery = useSelector(selectSearchQuery);

  // State

  const [isSortMode, setIsSortMode] = useState(false);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState(searchQuery);
  const [debouncedSearchTerm] = useDebounce(
    searchTerm,
    SEARCH_DEBOUNCE_TIMEOUT,
  );

  // Callbacks

  const toggleSort = useCallback(
    (property: SortFolderOptions['property']) => {
      let direction: SortFolderOptions['direction'] =
        property === 'updatedAt' ? 'desc' : 'asc';

      if (property === sortOptions.property) {
        direction = sortOptions.direction === 'asc' ? 'desc' : 'asc';
      }

      dispatch(actions.setSortOptions({ property, direction }));

      setIsSortMode(false);
    },
    [dispatch, setIsSortMode, sortOptions],
  );

  const toggleLayoutOptions = useCallback(() => {
    dispatch(
      actions.setLayoutOptions(layoutOptions === 'grid' ? 'list' : 'grid'),
    );

    setIsSortMode(false);
  }, [dispatch, layoutOptions]);

  // Side-effects

  useEffect(() => {
    if (debouncedSearchTerm !== searchQuery) {
      dispatch(actions.setSearchQuery(debouncedSearchTerm));
    }
  }, [debouncedSearchTerm, dispatch, searchQuery]);

  // Reset search query when exiting search mode.
  useEffect(() => {
    if (!isSearchMode) setSearchTerm('');
  }, [isSearchMode]);

  // Render

  let sortLabel = 'Sort';
  if (sortOptions.property === 'name') {
    sortLabel = `${sortLabel}: Name`;
  } else if (sortOptions.property === 'resourceType') {
    sortLabel = `${sortLabel}: Type`;
  } else if (sortOptions.property === 'updatedAt') {
    sortLabel = `${sortLabel}: Date`;
  }

  const isSortByName = sortOptions.property === 'name';
  const isSortByResourceType = sortOptions.property === 'resourceType';
  const isSortByDate = sortOptions.property === 'updatedAt';
  const isReverseSort = sortOptions.direction === 'desc';

  const sortActionOptions = (
    <div className="flex flex-col text-base font-regular text-gray-700 gap-1">
      <Button
        variant="unstyled"
        fullWidth
        className={cn(
          'flex items-center px-4 py-2.5 hover:bg-gray-100',
          isSortByName && 'bg-gray-200 hover:bg-gray-200',
        )}
        onPress={() => toggleSort('name')}
      >
        {isSortByName && isReverseSort ? (
          <ArrowDownArrowUp />
        ) : (
          <ArrowDownArrowUp transform="scale(-1,1)" />
        )}
        <span className="pl-3">Name</span>
      </Button>
      <Button
        variant="unstyled"
        fullWidth
        className={cn(
          'flex items-center px-4 py-2.5 hover:bg-gray-100',
          isSortByResourceType && 'bg-gray-200 hover:bg-gray-200',
        )}
        onPress={() => toggleSort('resourceType')}
      >
        {isSortByDate && isReverseSort ? (
          <ArrowDownArrowUp />
        ) : (
          <ArrowDownArrowUp transform="scale(-1,1)" />
        )}
        <span className="pl-3">Type</span>
      </Button>
      <Button
        variant="unstyled"
        fullWidth
        className={cn(
          'flex items-center px-4 py-2.5 hover:bg-gray-100',
          isSortByDate && 'bg-gray-200 hover:bg-gray-200',
        )}
        onPress={() => toggleSort('updatedAt')}
      >
        {isSortByDate && isReverseSort ? (
          <ArrowDownArrowUp />
        ) : (
          <ArrowDownArrowUp transform="scale(-1,1)" />
        )}
        <span className="pl-3">Date</span>
      </Button>
    </div>
  );

  const sortAction = (
    <>
      <Button
        variant="unstyled"
        className={cn(
          'text-lg font-medium text-gray-400 hover:text-blue-600 outline-none md:w-[114px]',
          isSortMode && 'text-blue-600',
        )}
        onPress={() => setIsSortMode(true)}
        isDisabled={sortDisabled}
      >
        <div className="flex items-center" ref={triggerRef}>
          <Filter />
          <span className="hidden pl-2.5 md:block">{sortLabel}</span>
        </div>
      </Button>
      <Popover
        triggerRef={triggerRef}
        isOpen={isSortMode}
        onOpenChange={setIsSortMode}
        className="w-[116px]"
        placement="bottom start"
      >
        <Dialog className="px-0 py-2.5" aria-label="sort options">
          <div className="overflow-hidden">{sortActionOptions}</div>
        </Dialog>
      </Popover>
    </>
  );

  const searchAction = (
    <>
      {isSearchMode ? (
        <div className="flex text-lg font-medium text-gray-400">
          <input
            autoFocus
            className="outline-none border-b-2 max-w-[140px] mr-1"
            type="text"
            placeholder="Search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Button
            variant="unstyled"
            className="text-gray-400 hover:text-blue-600 outline-none"
            onPress={() => setIsSearchMode(false)}
          >
            <XMark size={12} />
          </Button>
        </div>
      ) : (
        <Button
          variant="unstyled"
          className="flex items-center text-lg font-medium text-gray-400 enabled:hover:text-blue-600 outline-none"
          onPress={() => setIsSearchMode(true)}
        >
          <Search size={17} />
        </Button>
      )}
    </>
  );

  const layoutAction = (
    <div className="w-6 flex justify-end">
      <Button
        variant="unstyled"
        className="flex items-center text-lg font-medium text-gray-400 enabled:hover:text-blue-600 outline-none"
        onPress={() => toggleLayoutOptions()}
      >
        {layoutOptions === 'list' ? <GridIcon /> : <List size={16} />}
      </Button>
    </div>
  );

  const renderDesktopActionBar = () => (
    <>
      <div className="flex gap-6">{sortAction}</div>
      <div className="grow" />
      <div className="flex gap-2">
        {searchAction}
        {layoutAction}
      </div>
    </>
  );

  const renderMobileActionBar = () => (
    <>
      <div className="flex flex-1 justify-between mr-2">
        {sortAction}
        {layoutAction}
      </div>
      <div className="min-w-36 flex justify-end">{searchAction}</div>
    </>
  );

  return (
    <div className="w-full flex bg-white px-4 rounded-3xl h-10 items-center border-2">
      <Hidden smDown>{renderDesktopActionBar()}</Hidden>
      <Hidden mdUp>{renderMobileActionBar()}</Hidden>
    </div>
  );
};

export default AddContentActionBarV2;
